import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import InputAdornment from '@mui/material/InputAdornment';
import Business from '@mui/icons-material/Business';
import TextField from '@mui/material/TextField';
import { CITIES_LIST, HOT_CITIES } from '@/constants/data/city';
import { TAB_CITY_COMPARISON } from '@/constants/job-title';
import { trackClickEvent } from '@/utils/site-track';

type CityPickerProps = {
  value: string;
  onChange: (city: string) => void;
  helperText?: string;
};

const CityPicker = (props: CityPickerProps) => {
  const { value, onChange, helperText } = props;
  const [options, setOptions] = React.useState(HOT_CITIES.slice(0, 5));
  const [open, setOpen] = React.useState(false);
  const inputRef = React.useRef<HTMLInputElement | undefined>(undefined);

  return (
    <Autocomplete
      open={open}
      options={options}
      fullWidth
      popupIcon={<></>}
      value={value}
      filterOptions={(options) => options}
      onChange={(e, value) => {
        onChange(value);
        setOpen(false);
      }}
      selectOnFocus={false}
      onInputChange={(e, newInputValue) => {
        const searchValue = newInputValue.trim();
        if (searchValue) {
          setOptions(
            CITIES_LIST.filter(
              (city) =>
                city.pinyin.includes(searchValue.toLowerCase()) ||
                city.name.includes(searchValue),
            ).map((item) => {
              return item.name;
            }),
          );
        } else {
          setOptions(HOT_CITIES.slice(0, 5));
        }
      }}
      disableClearable={true}
      blurOnSelect={true}
      noOptionsText="抱歉，暂未搜索到相关城市"
      isOptionEqualToValue={(option, value) =>
        !!option && !!value && option === value
      }
      data-ele-group={`${TAB_CITY_COMPARISON}-comparison_city-select`}
      data-ele-id="city-select"
      onFocus={(e) => trackClickEvent(e)}
      renderInput={(param) => {
        param.InputProps['startAdornment'] = (
          <InputAdornment position="start">
            <div className="bg-gray-100 p-1 rounded-full flex tablet:p-2">
              <Business className="!text-xs tablet:!text-2xl tablet:!font-normal" />
            </div>
          </InputAdornment>
        );
        return (
          <TextField
            {...param}
            inputRef={inputRef}
            variant="outlined"
            error={!!helperText}
            helperText={helperText}
            placeholder="请选择城市"
            className="[&_.MuiInputBase-root]:px-2.5 [&_.MuiInputBase-root]:py-1 [&_input]:text-center tablet:[&_.MuiInputBase-root]:pl-2.5 tablet:[&_.MuiInputBase-root]:py-2.5 tablet:[&_input]:text-left"
            onFocus={() => setOpen(true)}
            onBlur={() => setOpen(false)}
          />
        );
      }}
    />
  );
};

export default CityPicker;
